import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {environment} from '../../environments/environment';

import {Filter} from '../components/order-entry/remittances/remittances.component'

@Injectable({
  providedIn: 'root'
})
export class RemittancesService {

  constructor(private http: HttpClient) { }
  urlEndPoint = environment.endPoint;
  getRemittances(filter: Filter) {

    const params = new URLSearchParams();
    params.set('user', (filter.user).toString())
    params.set('groupId', filter.groupId)
    params.set('startDate', filter.startDate.toLocaleDateString())
    params.set('endDate', filter.endDate.toLocaleDateString())
    params.set('remitted', filter.withRemittance)
    params.set('notRemitted', filter.withoutRemittance)


    if(filter.ward != ''){
      params.set('wardId', filter.ward.wardId);
      params.set('versionId', filter.ward.versionId)
    }

    return this.http.get<any>( `${this.urlEndPoint}/api/oe/remittance?${params.toString()}`)

  }

  createRemittance(orders){
    return this.http.post(this.urlEndPoint + '/api/oe/remittance-report', orders, {responseType: 'blob'});
  }

  insertRemittance(orders){
    return this.http.post(this.urlEndPoint + '/api/remittance/insert', orders);
  }

  deleteOrderFromRemittance(order){
    return this.http.post(this.urlEndPoint + '/api/remittance/delete', order);
  }

}
